import { FolderTree, Tag, Download, Repeat } from "lucide-react";
import type { SourceAction } from "../types";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

export interface BankingActionsConfig {
  onChangeCategory?: () => void;
  onTag?: () => void;
  onExport?: () => void;
  onMarkRecurring?: () => void;
}

export function buildBankingActions(cfg: BankingActionsConfig, i18n: I18n): SourceAction[] {
  return [
    {
      id: "category",
      label: i18n._(msg`Cambia categoria`),
      icon: <FolderTree className="h-3.5 w-3.5" />,
      variant: "primary",
      disabled: !cfg.onChangeCategory,
      onSelect: () => cfg.onChangeCategory?.(),
    },
    {
      id: "tag",
      label: i18n._(msg`Tag`),
      icon: <Tag className="h-3.5 w-3.5" />,
      disabled: !cfg.onTag,
      onSelect: () => cfg.onTag?.(),
    },
    {
      id: "export",
      label: i18n._(msg`Esporta`),
      icon: <Download className="h-3.5 w-3.5" />,
      disabled: !cfg.onExport,
      onSelect: () => cfg.onExport?.(),
    },
    {
      id: "recurring",
      label: i18n._(msg`Marca ricorrente`),
      icon: <Repeat className="h-3.5 w-3.5" />,
      disabled: !cfg.onMarkRecurring,
      onSelect: () => cfg.onMarkRecurring?.(),
    },
  ];
}
